const US_DEFAULT_MINIMUM = 10000;
const REDUCED_MINIMUM = 5000;
const CANADA_MINIMUM = 5000;

// US cities that qualify for the reduced flyering minimum.
// Values MUST match City.name exactly (compared against the selected city name).
// Note: "Hoboken / Jersey City" is a single combined market in the DB — there is
// no separate "Jersey City" or "Hoboken" record to match.
const US_REDUCED_MINIMUM_CITIES = new Set([
  "New York City",
  "Atlanta",
  "Boston",
  "Washington, D.C.",
  "Hoboken / Jersey City",
  "Philadelphia",
]);

interface MinimumCampaignValue {
  amount: number;
  formatted: string;
}

const toMinimum = (amount: number): MinimumCampaignValue => ({
  amount,
  formatted: `$${amount.toLocaleString()}`,
});

export const getMinimumCampaignValue = (
  countryName: string | undefined,
  cityName: string | undefined
): MinimumCampaignValue | null => {
  if (countryName === "United States") {
    const isReducedCity = !!cityName && US_REDUCED_MINIMUM_CITIES.has(cityName);
    return toMinimum(isReducedCity ? REDUCED_MINIMUM : US_DEFAULT_MINIMUM);
  }

  if (countryName === "Canada") {
    return toMinimum(CANADA_MINIMUM);
  }

  return null;
};

export const isBelowMinimumCampaignValue = (
  countryName: string | undefined,
  cityName: string | undefined,
  subtotal: number | undefined
): boolean => {
  const minimum = getMinimumCampaignValue(countryName, cityName);
  if (!minimum || subtotal == null) return false;
  return subtotal < minimum.amount;
};
